import * as fromRoot from '../../reducers';
import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as regionReducer from './regions.reducer';
import * as notificationsReducer from './notifications.reducer';
import * as menuReducer from './menu.reducer';
import * as settingsReducer from './settings.reducer';
import * as installationDashboardsReducer from './installation-dashboards.reducer';

export interface CoreState {
  regionState: regionReducer.State;
  notificationState: notificationsReducer.State;
  menuState: menuReducer.State;
  settingsState: settingsReducer.State;
  installationDashboardsState: installationDashboardsReducer.State;
}

export interface State extends fromRoot.State {
  coreState: CoreState;
}

export const reducers: ActionReducerMap<CoreState, Action> = {
  regionState: regionReducer.reducer,
  notificationState: notificationsReducer.reducer,
  menuState: menuReducer.reducer,
  settingsState: settingsReducer.reducer,
  installationDashboardsState: installationDashboardsReducer.reducer,
};


export const selectCoreState = createFeatureSelector<State, CoreState>('coreState');
export const selectRegionState = createSelector(selectCoreState, (state: CoreState) => state.regionState);
export const selectNotificationState = createSelector(selectCoreState, (state: CoreState) => state.notificationState);
export const selectMenuState = createSelector(selectCoreState, (state: CoreState) => state.menuState);
export const selectSettingsState = createSelector(selectCoreState, (state: CoreState) => state.settingsState);
export const selectInstallationDashboardsState = createSelector(selectCoreState, (state: CoreState) => state.installationDashboardsState);

export const getRegions = createSelector(selectRegionState, regionReducer.getRegions);

export const getNotifications = createSelector(selectNotificationState, notificationsReducer.getNotifications);
export const getNotificationStats = createSelector(selectNotificationState, notificationsReducer.getStats);
export const areNotificationsLoading = createSelector(selectNotificationState, notificationsReducer.areLoading);

export const getMenuState = createSelector(selectMenuState, menuReducer.getState);
export const getMenuActiveTab = createSelector(selectMenuState, menuReducer.getActiveTab);
export const isMenuHidden = createSelector(selectMenuState, menuReducer.isHidden);
export const isMenuLastClickedTabActive = createSelector(selectMenuState, menuReducer.isLastClickedTabActive);
export const isOpen = createSelector(selectMenuState, menuReducer.isOpen);

export const getLanguage = createSelector(selectSettingsState, settingsReducer.getLanguage);
export const getTimeZone = createSelector(selectSettingsState, settingsReducer.getTimeZone);
export const getSettings = createSelector(selectSettingsState, settingsReducer.getSettings);
export const getTag = createSelector(selectSettingsState, settingsReducer.getTag);

export const getInstallationDashboards = createSelector(selectInstallationDashboardsState, installationDashboardsReducer.getInstallationDashboards);
export const getInstallationDashboardsErrors = createSelector(selectInstallationDashboardsState, installationDashboardsReducer.getInstallationDashboardsErrors);

